import { APPEARANCE_VARIANTS, CLASSIC_VARIANT, type AppearanceVariant } from './variants';

type PreferenceStorage = Pick<Storage, 'getItem' | 'setItem'>;
export function resolveAppearance(
  id: string | null,
  available = APPEARANCE_VARIANTS.map((variant) => variant.id),
): AppearanceVariant {
  return (
    APPEARANCE_VARIANTS.find((variant) => variant.id === id && available.includes(variant.id)) ??
    CLASSIC_VARIANT
  );
}
export function appearanceKey(tenantId: string, userId: string): string {
  return `erp.appearance.v1:${JSON.stringify([tenantId, userId])}`;
}
export function readAppearance(
  storage: PreferenceStorage,
  tenantId: string,
  userId: string,
): AppearanceVariant {
  try {
    return resolveAppearance(storage.getItem(appearanceKey(tenantId, userId)));
  } catch {
    return CLASSIC_VARIANT;
  }
}
export function writeAppearance(
  storage: PreferenceStorage,
  tenantId: string,
  userId: string,
  id: string,
): void {
  try {
    storage.setItem(appearanceKey(tenantId, userId), resolveAppearance(id).id);
  } catch {
    /* Storage is optional; the current selection remains usable in memory. */
  }
}
